import enterpriseFormService from "@/services/enterprises/enterpriseFormService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";
import mapKeys from "lodash/mapKeys";
const efs = enterpriseFormService;

const INITIAL_STATE = {
  enterpriseForms: [
    // {
    //   form_versions: [
    //     {
    //       form_version_items: [
    //         {
    //           caution_min: 0,
    //           default_value: "string",
    //           default_value_id: "string",
    //           format: "string",
    //           id: "string",
    //           input_type: 0,
    //           label: "string",
    //           nullable_label: "string",
    //           required: true,
    //           select_options: [{}],
    //           sort_order: 0,
    //           unit: "string",
    //           validators: {},
    //           warning_min: 0,
    //         },
    //       ],
    //       id: "string",
    //       start_at: "2024-03-25T07:33:00.655Z",
    //       version_no: 0,
    //     },
    //   ],
    //   id: "string",
    // },
  ], // : EnterpriseForm[]
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    /**
     * enterprise form 設定をセットするミューテーション
     *
     * @param {Object} state - Vuex ストアの状態オブジェクト
     * @param {EnterpriseForm[]} data - データ
     * @returns {void}
     */
    SET_ENTERPRISE_FORMS(state, data) {
      state.enterpriseForms = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * enterprise form 設定 を storeにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<Boolean>}
     * @throws {Error}
     */
    async setEnterpriseForms({ commit }) {
      const enterpriseForms = await efs.getEnterpriseForms();
      commit("SET_ENTERPRISE_FORMS", enterpriseForms.data || []);
      operationLocalDbService.setEnterpriseFormsToLocalDB(
        enterpriseForms.data || []
      );
    },

    /**
     * enterprise forms  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setEnterpriseFormsFromLocalDB({ commit }) {
      const enterpriseForms = await operationLocalDbService.getEnterpriseFormsFromLocalDB();
      commit("SET_ENTERPRISE_FORMS", enterpriseForms || []);
    },

    /**
     * enterprise forms  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setEnterpriseFormsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setEnterpriseFormsFromLocalDB");
      if (!getters.hasEnterpriseForms) {
        dispatch("setEnterpriseForms");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    validEnterpriseForms({ enterpriseForms }) {
      return efs.validEnterpriseForms(enterpriseForms);
    },

    // enterpriseForm の FormVersion["id"] を key にしたマップ
    enterpriseFormMapByFormVersionId(_, { validEnterpriseForms }) {
      return validEnterpriseForms.reduce((acc, form) => {
        form.form_versions.forEach(fv => {
          acc[fv.id] = form;
        });
        return acc;
      }, {});
    },

    hasEnterpriseForms(_, { validEnterpriseForms }) {
      return validEnterpriseForms.length > 0;
    },

    enterpriseFormVersions(_, { validEnterpriseForms }) {
      return efs.enterpriseFormVersions(validEnterpriseForms);
    },

    enterpriseFormVersionItems(_, { enterpriseFormVersions }) {
      return efs.enterpriseFormVersionItems(enterpriseFormVersions);
    },

    // enterpriseFormVersion の id を key にしたマップ
    enterpriseFormVersionMap(_, { enterpriseFormVersions }) {
      return mapKeys(enterpriseFormVersions, "id");
    },

    // form_version_item_id でひけるMap => レポートとかで使う
    enterpriseFormVersionItemMap(_, { enterpriseFormVersionItems }) {
      return mapKeys(enterpriseFormVersionItems, "id");
    },
  },
};
